export default "__VITE_ASSET__bsRwaqiQ__"